<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/avNvVs/CoverDesign.jpg?1684515570574" alt="This image is the cover for the book The Spy's Love Song, Dreamspun Desires"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Spy's Love Song, Dreamspun Desires
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>A Stars from Peril Novel</i></b></p><p>For a singer and a spy, love might be mission impossible.</p> <p>Jaxon Powers has what most only dream of. Fame. Fortune. Gold records and Grammy awards. Lavish hotel suites and an endless parade of eager bedmates. He’s adored all over the world—even in the remote, repressive country of Vasnytsia, where the tyrannical dictator is a big fan. The State Department hopes a performance might improve US relations with a dangerous enemy. But it means Jaxon’s going in alone… with one exception.</p> <p>Secret agent Reid Stanfill has a covert agenda with global ramifications. Duty means everything to him, even when it involves protecting a jaded rock star. Jaxon and Reid’s mutual attraction is dangerous under Vasnytsia’s harsh laws—and matters get even worse when they’re trapped inside the borders. Romance will have to wait… assuming they make it out alive.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kim Fielding
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?46df496b